"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutorestExtensionLogger = void 0;
const types_1 = require("./types");
class AutorestExtensionLogger {
    constructor(sendMessage) {
        this.sendMessage = sendMessage;
    }
    debug(message) {
        this.log({ level: "debug", message });
    }
    verbose(message) {
        this.log({ level: "verbose", message });
    }
    info(message) {
        this.log({ level: "info", message });
    }
    warning(message, key, source, details) {
        this.log({ level: "warning", message, key, source, details });
    }
    error(message, key, source, details) {
        this.log({ level: "error", message, key, source, details });
    }
    fatal(message, key, source, details) {
        this.log({ level: "fatal", message, key, source, details });
    }
    log(info) {
        const sources = info.source ? [info.source] : [];
        this.sendMessage({
            Channel: getChannel(info.level),
            Key: info.key,
            Source: sources,
            Text: info.message,
            Details: info.details,
        });
    }
}
exports.AutorestExtensionLogger = AutorestExtensionLogger;
function getChannel(level) {
    switch (level) {
        case "debug":
            return types_1.Channel.Debug;
        case "verbose":
            return types_1.Channel.Verbose;
        case "info":
            return types_1.Channel.Information;
        case "warning":
            return types_1.Channel.Warning;
        case "error":
            return types_1.Channel.Error;
        case "fatal":
            return types_1.Channel.Fatal;
    }
}
//# sourceMappingURL=extension-logger.js.map